import { Tab, Nav } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import AgentCommissionChangeList from "./AgentCommissionChangeList";
import { useEffect, useState } from "react";
import { getAgentComChangeList } from '@src/store/slices/insuranceId';
import secureStorage from "@src/config/encrypt";
import CommonModel from "@pages/commission/commonModel";
import { COUNTRY_CODE } from '@src/config/constant';
import FullPageLoader from "@common/FullPageLoader";
import { useLanguage } from "@src/context/LanguageContext";


const AgentCommissionChangePage = () => {
    const [searchParams] = useSearchParams();
    //const defaultStatus = Number(searchParams.get("status")) || 1;
    let [loading, setLoading] = useState<boolean>(false)

    const statusParam = searchParams.get("status");
    const defaultStatus = statusParam !== null ? Number(statusParam) : 1;

    const [activeTab, setActiveTab] = useState<number>(defaultStatus);
    const [insuranceList, setInsuranceList] = useState<any[]>([]);
    const [paginationData, setPaginationData] = useState<any>({});
    const [showbankModel, setShowbankModel] = useState(false);
    const [tabCounts, setTabCounts] = useState<any[]>([]);
    const {translations} = useLanguage();
    const isCountryId = COUNTRY_CODE === 'id' ? true : false;

    const [selectedFilters, setSelectedFilters] = useState<any>({
        status_type: defaultStatus,
        searchKey: "",
    });
    const [trigger, setTrigger] = useState(0);


    useEffect(() => {
        const updated = {
            ...selectedFilters,
            status_type: activeTab,
            page_number: 1,
        };
        setSelectedFilters(updated);
        fetchListing(updated);
    }, [activeTab, trigger]);


    const user_data = secureStorage.getItem("authAgentUserInfo");


    const fetchListing = (filters: any) => {
        setLoading(true);
        const params = {
            status_id: filters.status_type,
            search_text: filters.searchKey,
            page_number: filters.page_number || 1,
            role_id: user_data.user_data.role_id,
            user_id: user_data.user_data.user_id,
        };

        getAgentComChangeList(params).then((res: any) => {
            if(res.status === 200){
                setInsuranceList(res.data);
                setPaginationData(res.pagination);
                setTabCounts(res.tabCount || []);
                setLoading(false);
            }else{
                setLoading(false);
            }
        });
    };


    const setSearchKeyword = (searchKey: any) => {
        setSelectedFilters((prev: any) => ({
            ...prev,
            searchKey,
        }));
    };

    const handleKeyDown = (event: any) => {
        if (event.key === "Enter") {
            fetchListing({ ...selectedFilters, page_number: 1 });
        }
    };

    return (
        <div className="container-fluid wap-bg-white">
            <FullPageLoader show={loading} />
            <div className="top-heading financer-lead-heding insurance-top-filer-heading d-flex">

                <h1>{translations?.AGENT_COMMISSION?.AGENT_LIST}</h1>
                <span>
                    <button className="btn-line btn-width-auto" onClick={() => setShowbankModel(true)} > {translations?.TASK_SUMMARY?.OTO_BANK}</button>
                </span>
            </div>

            <div className="loan-filter-bg">
                <div className=" insurnace-appliction-table-outer">
                    <Tab.Container
                        id="left-tabs-example"
                        activeKey={activeTab}
                        onSelect={(k: any) => setActiveTab(Number(k))}
                    >
                        <Nav
                            variant="pills"
                            className="flex-column nav nav-pills nav nav-pills nav nav-pills tab-application-id"
                        >
                            <div className="tab-list">
                                {tabCounts?.map((data: any) => (
                                    <Nav.Item key={data.type}>
                                        <Nav.Link eventKey={data.filter_params.status_id}>
                                            {/* {data.label} ({data.count}) */}
                                            {translations?.AGENT_COMMISSION?.STATUS_NAME?.[data.label] ?? data.label}
                                            <span className="m-xs-l count-chip-bg">{data.count}</span>
                                        </Nav.Link>
                                    </Nav.Item>
                                ))}
                            </div>

                            <div className="d-flex">
                                <fieldset className="search-bx">
                                    <div className="material" title='Search Agent'>
                                        <input id="" type="text"
                                            placeholder= {translations?.AGENT_COMMISSION?.SEARCH_AGENT}
                                            name="RoleName" className="form-input lead_search_input"
                                            value={selectedFilters?.searchKey || ""}
                                            onChange={(e) => setSearchKeyword(e.target.value)}
                                            onKeyDown={handleKeyDown}
                                        />
                                        <i className="ic-search"></i>
                                    </div>
                                </fieldset>

                            </div>

                        </Nav>

                        <Tab.Content>
                            <Tab.Pane eventKey={activeTab}>
                                <AgentCommissionChangeList
                                    insuranceList={insuranceList}
                                    paginationData={paginationData}
                                    getInsuranceListing={({ page_number }: any) =>
                                        fetchListing({ ...selectedFilters, page_number })
                                    }
                                    selectedFilters={selectedFilters}
                                    current_nav={true}
                                    setTrigger={setTrigger}
                                    setLoading= {setLoading}
                                />
                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </div>
            </div>

            {

                isCountryId && <CommonModel filterType="Bank Details" show={showbankModel} handleClose={() => { setShowbankModel(false) }} />

            }
        </div>
    );
};

export default AgentCommissionChangePage;
